import NavIcon from "../components/nav-icon"
import BannerRight from "../components/banner-right"
import WrapperBlog from "../components/blog/wrapper-blog"

const Blog = ()=> {
    return (
        <>
        <NavIcon/>
        <BannerRight/>
        <WrapperBlog/>
        </>
    )
}
export default Blog